<template>
  <div class="u-mg-b-2">
    <loading-full-page :active="showLoading"></loading-full-page>
    <template v-if="lastPayee === PAYEE.CREDIT_CODE && ccNumber">
      <form
        action="/payment/complete"
        method="post"
        ref="form"
      >
        <input type="hidden" name="_token" :value="csrfToken">
        <input type="hidden" name="cpno" :value="cpno">
        <input type="hidden" name="order_id" :value="orderId">
        <input type="hidden" v-for="(value, key) in formParam" :key="key" :name="key" :value="value">
        <input type="hidden" name="token" :value="token" v-if="token">
        <input type="hidden" name="tokenKey" :value="tokenKey" v-if="tokenKey">
        <input type="hidden" name="cc_number" :value="maskedCcNumber" v-if="maskedCcNumber">
        <div class="submit">
          <button
            class="btn"
            data-block="true"
            data-color="brand"
            type="button"
            @click="openModal()"
          >登録済みのカードで購入</button>
        </div>

        <app-modal-simple
          title
          :active="isShowModal"
          @close="closeModal()"
          :location-path="ga_location"
          :showheader="true"
          :showfooter="false"
          class="simple payment"
          :close="true"
        >
          <div slot="content" class="content">
            <div class="content__inner">
              <div class="caption u-tx-center">
                <span class="u-tx-bold u-tx-size-16 u-tx-brand-0">購入内容の確認</span>
              </div>
              <div class="description u-tx-brand">
                <span>{{ itemName }}</span>
              </div>
              <hr class="contentSeparatorSection gray-10 u-mg-t-2 u-mg-b-2">
              <div class="content__price">
                <span class="u-width-10">価格</span>
                <div class="u-width-10 u-tx-right">
                  <span class="content__value">¥{{ itemPrice | addComma }}</span>
                  <span class="tax">(税込)</span>
                </div>
              </div>
              <hr class="contentSeparatorSection gray-10 u-mg-t-2 u-mg-b-3">

              <div class="type u-mg-b-3">
                <span class="u-width-10">お支払い方法</span>
                <span class="u-width-10 u-tx-right">クレジットカード</span>
              </div>
              <div class="u-mg-l-1">
                <div class="flexbox u-mg-b-2">
                  <span class="label u-tx-size-13">カード番号</span>
                  <span class="content__value colorBlk">{{ccNumber}}</span>
                </div>
                <div class="flexbox">
                  <span class="label u-tx-size-13">カード有効期限</span>
                  <span class="content__value colorBlk">{{ ccExpiration | addSlashToCalendarYM }}</span>
                </div>
              </div>
              <hr class="contentSeparatorSection gray-10 u-mg-t-2 u-mg-b-4">
            </div>

            <!-- ボタン -->
            <div class="actionarea">
              <div class="button default" @click="closeModal()">
                <span>修正</span>
              </div>
              <button
                href
                class="button brand-0"
                type="submit"
                @click="handleSubmit"
                :disabled="processing"
              >
                <span>購入を確定</span>
              </button>
            </div>
          </div>
        </app-modal-simple>
      </form>
      <template v-if="formFlg">
      <form
        action="/payment/change_payment_input"
        method="post"
        class="carrierButtonGroup__item u-mg-b-3 u-mg-t-2">
        <input type="hidden" name="_token" :value="csrfToken" >
        <input type="hidden" name="items_id" :value="itemsId">
        <input type="hidden" name="guestId" :value="guestId">
        <input type="hidden" name="pay_type" value="card">
        <div class="organize__label" v-if="cardNumberStr">
          <span :class="['value',{'disabled':!cardNumberStr}]">{{ cardNumberStr }}</span>
        </div>
        <div class="carrierButtonGroup__item__change">
          <button type="submit" class="carrierButtonGroup__item__change__Btn">変更</button>
        </div>
      </form>
      <div class="paymentChange">
        <form
          action="/payment/change_payment_input"
          method="post"
          class="paymentChange__item">
          <input type="hidden" name="_token" :value="csrfToken" >
          <input type="hidden" name="items_id" :value="itemsId">
          <input type="hidden" name="guestId" :value="guestId">
          <input type="hidden" name="pay_type" value="carrier">
          <button type="submit" class="paymentChange__button js-carrierBtn">
            {{ PAYEE.CARRIER_LABEL }}
          </button>
        </form>
        <form
          action="/payment/change_payment_input"
          method="post"
          class="paymentChange__item">
          <input type="hidden" name="_token" :value="csrfToken" >
          <input type="hidden" name="items_id" :value="itemsId">
          <input type="hidden" name="guestId" :value="guestId">
          <input type="hidden" name="pay_type" value="pay">
          <button type="submit" class="paymentChange__button js-carrierBtn">
            {{ PAYEE.PAY_LABEL }}
          </button>
        </form>
      </div>
    </template>
    </template>
    <template v-else-if="!!PayeeCode">
      <form
        @submit.prevent="executeSettlement($event, lastPayee)"
        :action="sbpsApiUrl"
        method="post"
        :accept-charset="acceptCharset"
      >
        <input
          v-for="(value, key) in paymentArray"
          :key="key"
          type="hidden"
          :name="key"
          :value="value"
        >
        <button
          type="submit"
          class="btn"
          data-block="true"
          data-color="primary"
        >{{ PAYEE.CARRIER_LABEL }}</button>
      </form>
      <template v-if="formFlg">
      <form
        action="/payment/change_payment_input"
        method="post"
        class="carrierButtonGroup__item u-mg-b-3 u-mg-t-2">
        <input type="hidden" name="_token" :value="csrfToken" >
        <input type="hidden" name="items_id" :value="itemsId">
        <input type="hidden" name="guestId" :value="guestId">
        <input type="hidden" name="pay_type" value="carrier">
        <div class="organize__label">
          <span>{{ PayeeCode }}</span>
        </div>
        <div class="carrierButtonGroup__item__change">
          <button type="submit" class="carrierButtonGroup__item__change__Btn">変更</button>
        </div>
      </form>
      <div class="paymentChange">
        <form
          action="/payment/change_payment_input"
          method="post"
          class="paymentChange__item">
          <input type="hidden" name="_token" :value="csrfToken" >
          <input type="hidden" name="items_id" :value="itemsId">
          <input type="hidden" name="guestId" :value="guestId">
          <input type="hidden" name="pay_type" value="card">
          <button type="submit" class="paymentChange__button js-carrierBtn">
            クレジットカードを使う
          </button>
        </form>
        <form
          action="/payment/change_payment_input"
          method="post"
          class="paymentChange__item">
          <input type="hidden" name="_token" :value="csrfToken" >
          <input type="hidden" name="items_id" :value="itemsId">
          <input type="hidden" name="guestId" :value="guestId">
          <input type="hidden" name="pay_type" value="pay">
          <button type="submit" class="paymentChange__button js-carrierBtn">
            {{ PAYEE.PAY_LABEL }}
          </button>
        </form>
      </div>
    </template>
    </template>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import paymentMixins from './payment-mixins'
import { PAYEE } from '@/CONSTS'
import * as type from '@/utvStore/store/mutation-types'
let initialLocation = location.origin + location.pathname

export default {
  name: 'last-payment',
  mixins: [paymentMixins],
  data() {
    return {
      PAYEE,
      ga_location: initialLocation,
      isShowModal: false,
      requiredFieldsBool: false,
      showLoading: false,
      processing: false,
      paymentArray: '',
      PayeeCode: ''
    }
  },
  beforeMount() {
    this.getPaymentData()
  },
  computed: {
    ...mapState({
      lastPayee: state => state.payment.lastPayee
    }),
    ...mapGetters(['cardNumberStr'])
  },
  props: {
    orderId: { type: String, required: true },
    formParam: Object,
    ccNumber: String,
    ccExpiration: String,
    itemName: String,
    itemPrice: [String, Number],
    itemsId: String,
    guestId: String,
    formFlg: { type: Boolean, default: false }
  },
  mounted() {
    this.checkCarrierMethod(this.lastPayee)
  },
  watch: {
    lastPayee(val){
      this.checkCarrierMethod(val)
    }
  },
  methods: {
    checkCarrierMethod(val){
      this.paymentArray =
        (val === this.PAYEE.DOCOMO_CODE) ? this.docomoInformalPaymentArray
          :(val === this.PAYEE.KDDI_CODE) ? this.kddiInformalPaymentArray
          :(val === this.PAYEE.SOFTBANK_CODE) ? this.softbankInformalPaymentArray : ''
      this.PayeeCode =
        (val === this.PAYEE.DOCOMO_CODE) ? this.PAYEE.DOCOMO_LABEL
          :(val === this.PAYEE.KDDI_CODE) ? this.PAYEE.KDDI_LABEL
          :(val === this.PAYEE.SOFTBANK_CODE) ? this.PAYEE.SOFTBANK_LABEL : ''
    },
    openModal() {
      // GA送信
      window.gtag('event', 'PaymentCheckModal', {
        page_location: initialLocation + '/paymentcheck'
      })
      this.isShowModal = true
    },
    closeModal() {
      this.processing = false
      this.isShowModal = false
    },
    handleSubmit() {
      this.processing = true
      this.showLoading = true
      this.$refs.form.submit()
    }
  }
}
</script>

<style lang="scss" scoped>
.securityCode {
  position: relative;
  &__question {
    position: absolute;
    left: 88px;
    top: 25px;
    cursor: pointer;
  }
  &__about {
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 8px;
    z-index: 2;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
    border-radius: 4px;
    left: 120px;
    top: 0;
    align-items: center;
    pointer-events: none;
    opacity: 0;
    transition: opacity 250ms ease-in-out;
    &[data-visible='true'] {
      opacity: 1;
      pointer-events: auto;
    }
    .media__content p {
      font-size: 10px;
      line-height: 14px;
    }
  }
}

.modal {
  &.simple {
    .actionarea {
      display: flex;
      margin: 0 -7px;

      .button {
        width: 100%;
        outline: 0;
        margin: 0 7px;
      }
    }
  }
  // payment_modal
  &.payment {
    .close {
      width: 48px;
      float: right;
    }

    .modal__content {
      border-radius: 2px;
    }

    .modal__header {
      position: absolute;
      width: 100%;
    }

    .modal__body {
      .content {
        padding: 24px 16px;

        &__inner {
          .caption {
            line-height: 16px;
            margin-bottom: 24px;
          }
          .type {
            display: flex;
          }
          .flexbox {
            display: flex;
          }
          .label {
            width: 100%;
          }
        }
      }
    }
  }
}
.content__price {
  display: flex;
}
.content__value {
  width: 100%;
  text-align: right;
}
.colorBlk {
  color: #000000;
}
.organize__label {
  width: calc(70% - 10px);
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Payment/LastPayment.vue